module.exports = __webpack_public_path__ + "static/img/no-adderss.594ac1de.png";